<div class="space-y-6">
  <!-- Feature Link Configuration Hub -->
  <div
    class="card-bg rounded-2xl p-6 border border-slate-200 dark:border-white/5 backdrop-blur-xl animate-in slide-in-from-top-4 duration-500 relative z-50 !overflow-visible">
    <h2 class="text-xl font-bold bg-gradient-to-r from-violet-400 to-indigo-500 bg-clip-text text-transparent mb-6">
      Product & Feature Linking
    </h2>

    <div class="grid grid-cols-12 gap-4 md:gap-6">
      <div class="col-span-12 md:col-span-6 lg:col-span-4">
        <app-dropdown title="Primary Product" [options]="productOptions()" [selectedValue]="String(selectedProductId())"
          selectionMode="single" placeholder="Select Product" [fullWidth]="true" variant="themeBase" size="lg"
          (selectionChange)="onProductChange($event)" />
      </div>

      <div class="col-span-12 md:col-span-6 lg:col-span-5">
        <app-dropdown title="Map Capability From Library" [options]="featureOptions()"
          [selectedValue]="String(newMapping.feature_id)" selectionMode="single" placeholder="Select Feature To Link"
          [fullWidth]="true" variant="themeBase" size="lg" (selectionChange)="onFeatureSelection($event)" />
      </div>

      <div class="col-span-12 md:col-span-12 lg:col-span-3">
        <!-- Hidden label for alignment -->
        <label class="hidden lg:block mb-1.5 text-sm font-medium opacity-0 pointer-events-none select-none">Action</label>
        <app-button variant="primary" (buttonClick)="createMapping()"
          [disabled]="!selectedProductId() || !newMapping.feature_id" className="w-full !h-12">
          Establish Link
        </app-button>
      </div>
    </div>
  </div>

  <!-- Capability Link Grid -->
  @if (!selectedProductId()) {
  <div
    class="p-12 text-center card-bg rounded-2xl border border-dashed border-slate-300 dark:border-slate-700 flex flex-col items-center gap-3">
    <div class="w-10 h-10 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-lg">📁</div>
    <p class="text-slate-500">Select a Product above to view established capability mappings.</p>
  </div>
  } @else {
  <div class="card-bg rounded-2xl p-6 border border-slate-200 dark:border-white/5 animate-in fade-in duration-700">
    <h3 class="text-lg font-semibold text-slate-800 dark:text-slate-200 mb-6">
      Active Capability Matrix
    </h3>

    <app-paginated-table [headers]="headers" [tableData]="processedMappings()" [isCheckboxShow]="false"
      [tableActionOptions]="{ showToggleButton: true, toggleOptions: actionOptions }"
      (actionSelected)="handleAction($event)" [tableWrapperClass]="'!h-auto !overflow-x-auto !bg-transparent !backdrop-blur-none !shadow-none !border-none'"/>
  </div>
  }

  <!-- System Feedback -->
  @if (successMessage()) {
  <app-alert [message]="successMessage()" type="success" [duration]="3000" (close)="successMessage.set('')" />
  }
</div>